export const live = {
  url: "https://www.admin.panchavaktraya.com",
  imgUrl: "https://www.admin.panchavaktraya.com/public/image/",
  productImg: "https://www.admin.panchavaktraya.com/public/image/products/",
  certificateImg: "https://www.admin.panchavaktraya.com/public/image/vcertificate/",
  companyUrl: "https://www.admin.panchavaktraya.com/public/image/company/",
  planUrl: "https://www.admin.panchavaktraya.com/public/image/membership/",
  gallery: "https://www.admin.panchavaktraya.com/public/image/gallery/",
  trendProduct: "https://www.admin.panchavaktraya.com/public/image/trendingproduct/",
  categorycard: "https://www.admin.panchavaktraya.com/public/image/categorycard/",
  bannerUrl: "https://www.admin.panchavaktraya.com/public/image/banners/",
  logosUrl: "https://www.admin.panchavaktraya.com/public/image/logos/",
  blogImg: "https://www.admin.panchavaktraya.com/public/image/blogs/",
}

export const local = {
  url: "http://localhost:8003",
  imgUrl: "http://localhost:8003/public/image/",
  productImg: "http://localhost:8003/public/image/products/",
  trendProduct: "http://localhost:8003/public/image/trendingproduct/",
  certificateImg: "http://localhost:8003/public/image/vcertificate/",
  gallery: "http://localhost:8003/public/image/gallery/",
  blogImg: "http://localhost:8003/public/image/blogs/",
  categorycard: "http://localhost:8003/public/image/categorycard/",
  companyUrl: "http://localhost:8003/public/image/company/",
  planUrl: "http://localhost:8003/public/image/membership/",
  bannerUrl: "http://localhost:8003/public/image/banners/",
  logosUrl: "http://localhost:8003/public/image/logos/",
}

export const api =  process.env.NODE_ENV === "development" ? local : live